import Icon from '../components/Icon.vue'

Icon.register({
  server: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M480 160H32C14.3 160 0 145.7 0 128V64C0 46.3 14.3 32 32 32H480C497.7 32 512 46.3 512 64V128C512 145.7 497.7 160 480 160zM432 72C418.7 72 408 82.7 408 96S418.7 120 432 120 456 109.3 456 96 445.3 72 432 72zM368 72C354.7 72 344 82.7 344 96S354.7 120 368 120 392 109.3 392 96 381.3 72 368 72zM480 320H32C14.3 320 0 305.7 0 288V224C0 206.3 14.3 192 32 192H480C497.7 192 512 206.3 512 224V288C512 305.7 497.7 320 480 320zM432 232C418.7 232 408 242.7 408 256S418.7 280 432 280 456 269.3 456 256 445.3 232 432 232zM368 232C354.7 232 344 242.7 344 256S354.7 280 368 280 392 269.3 392 256 381.3 232 368 232zM480 480H32C14.3 480 0 465.7 0 448V384C0 366.3 14.3 352 32 352H480C497.7 352 512 366.3 512 384V448C512 465.7 497.7 480 480 480zM432 392C418.7 392 408 402.7 408 416S418.7 440 432 440 456 429.3 456 416 445.3 392 432 392zM368 392C354.7 392 344 402.7 344 416S354.7 440 368 440 392 429.3 392 416 381.3 392 368 392z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/server.js
// module id = MVsx
// module chunks = 144